import { gql } from '@apollo/client'

export const GET_WORKFLOWS_QUERY = gql`
  query workflows {
    workflows {
      id
      uuid
      name
      agent {
        id
        uuid
        firstName
        label
        jobTitle
        profileImageUrl
        shortDescription
        description
        createdAt
        createdBy {
          firstName
          lastName
          id
        }
      }
      tasks {
        id
        uuid
        name
        description
        task
        outputWebhookUrl
        runSchedule
        createdAt
        taskType
        status
        createdBy {
          firstName
          lastName
          id
        }
      }
      description
      createdAt
      createdBy {
        firstName
        lastName
        id
      }
    }
  }
`

export const GET_WORKFLOW_QUERY = gql`
  query workflow($uuid: ID!) {
    workflow(uuid: $uuid) {
      id
      uuid
      name
      agent {
        id
        uuid
        firstName
        label
        jobTitle
        profileImageUrl
        shortDescription
        description
        createdAt
        createdBy {
          firstName
          lastName
          id
        }
      }

      tasks {
        id
        uuid
        name
        description
        task
        outputWebhookUrl
        runSchedule
        createdAt
        taskType
        status
        createdBy {
          firstName
          lastName
          id
        }
      }

      description
      createdAt
      createdBy {
        firstName
        lastName
        id
      }
    }
  }
`

export const DELETE_WORKFLOW_MUTATION = gql`
  mutation deleteWorkflow($uuid: String!) {
    deleteWorkflow(uuid: $uuid) {
      success
      errors
    }
  }
`

export const CREATE_WORKFLOW_MUTATION = gql`
  mutation createWorkflow($name: String!, $description: String!, $agentUuid: String!) {
    createWorkflow(name: $name, description: $description, agentUuid: $agentUuid) {
      workflow {
        uuid
      }
      success
      errors
    }
  }
`

export const UPDATE_WORKFLOW_MUTATION = gql`
  mutation updateWorkflow(
    $uuid: String!
    $name: String!
    $description: String!
    $agentUuid: String!
  ) {
    updateWorkflow(uuid: $uuid, name: $name, description: $description, agentUuid: $agentUuid) {
      success
      errors
    }
  }
`

export const GET_TASKS_QUERY = gql`
  query tasks {
    tasks {
      id
      uuid
      name
      description
      task
      taskType
      uuid
      createdAt
      outputWebhookUrl
      runSchedule
      createdBy {
        firstName
        lastName
        id
      }
    }
  }
`

export const GET_TASK_QUERY = gql`
  query task($uuid: ID!) {
    task(uuid: $uuid) {
      id
      uuid
      name
      description
      task
      status
      taskType
      outputWebhookUrl
      runSchedule
      createdAt
      createdBy {
        firstName
        lastName
        id
      }
      workflow {
        uuid
        name
        description
      }
    }
  }
`

export const CREATE_TASK_MUTATION = gql`
  mutation createTask(
    $name: String!
    $description: String!
    $task: String!
    $taskType: String!
    $outputWebhookUrl: String!
    $runSchedule: String!
    $workflowUuid: String!
  ) {
    createTask(
      name: $name
      description: $description
      task: $task
      taskType: $taskType
      outputWebhookUrl: $outputWebhookUrl
      runSchedule: $runSchedule
      workflowUuid: $workflowUuid
    ) {
      success
      errors
    }
  }
`

export const UPDATE_TASK_MUTATION = gql`
  mutation updateTask(
    $uuid: String!
    $name: String!
    $description: String!
    $task: String!
    $taskType: String!
    $outputWebhookUrl: String!
    $runSchedule: String!
  ) {
    updateTask(
      uuid: $uuid
      name: $name
      description: $description
      task: $task
      taskType: $taskType
      outputWebhookUrl: $outputWebhookUrl
      runSchedule: $runSchedule
    ) {
      success
      errors
    }
  }
`

export const DELETE_TASK_MUTATION = gql`
  mutation deleteTask($uuid: String!) {
    deleteTask(uuid: $uuid) {
      success
      errors
    }
  }
`

export const SUBMIT_RUN_TASK_MUTATION = gql`
  mutation submitRunTask($uuid: String!) {
    submitRunTask(uuid: $uuid) {
      success
      errors
    }
  }
`

export const GET_TASK_RUNS_QUERY = gql`
  query taskRuns($taskUuid: ID!) {
    taskRuns(taskUuid: $taskUuid) {
      id
      uuid
      status
      state
      createdAt
      startedAt
      completedAt
      runtimeSeconds

      webhookResponseStatus
      webhookStatus
      webhookCompletedAt

      task {
        task
      }
      messageHistory {
        message {
          type
          value
        }
        actor
        createdAt
      }

      requestMessage
      responseMessage
      responseStatus

      evaluationMessage {
        reason
        status
      }
    }
  }
`

export const GET_AGENT_WORKFLOWS = gql`
  query agentWorkflows($agentUuid: ID!) {
    agentWorkflows(agentUuid: $agentUuid) {
      id
      uuid
      name
      description
      createdAt
      tasks {
        id
        uuid
        name
        description
        task
        outputWebhookUrl
        runSchedule
        createdAt
        taskType
        status
        createdBy {
          firstName
          lastName
          id
        }
      }
      agent {
        id
        uuid
        firstName
        label
        jobTitle
        profileImageUrl
        shortDescription
        description
        createdAt
        createdBy {
          firstName
          lastName
          id
        }
      }
      createdBy {
        firstName
        lastName
        id
      }
    }
  }
`

export const GET_WORKFLOW_TEMPLATES = gql`
  query workflowTemplates {
    workflowTemplates {
      uuid
      name
      description
      tasks {
        name
        description
        task
        runSchedule
        taskType
      }
    }
  }
`

export const CREATE_WORKFLOW_FROM_TEMPLATE = gql`
  mutation createWorkflowFromTemplate($templateUuid: String!, $agentUuid: String!) {
    createWorkflowFromTemplate(templateUuid: $templateUuid, agentUuid: $agentUuid) {
      success
      errors
    }
  }
`

export const MUTATION_TASK_RUN_MARK_PASSED = gql`
  mutation taskRunMarkPassed($uuid: String!) {
    taskRunMarkPassed(uuid: $uuid) {
      success
      errors
    }
  }
`
